export const barsData = {
  red: {
    id: 'red',
    name: 'Plan T',
    variant: 'RED',
    subtitle: "Men's Nutrition Bar",
    tagline: 'Dates · Almonds · Pumpkin Seeds · Beets',
    description:
      'Rich and earthy with a deep, satisfying bite. Built on whole Medjool dates and beets, with almonds and pumpkin seeds for texture and a clean finish of coconut oil and sea salt.',
    status: 'Coming Soon',
    netWeight: '1.8 oz (50g)',
    registration: '26-437',
    allergens: 'Contains: Tree Nuts (Almonds)',
    keyMineral: 'Zinc',
    productImage: '/Plan T Red Individual.png',
    tags: ['Whole Food', 'No Artificial Additives', '6 Ingredients', 'Small Batch', 'Handcrafted'],
    keyNutrients: [
      { name: 'Zinc',            source: 'Pumpkin seeds and almonds', description: 'An essential trace mineral found in pumpkin seeds and almonds' },
      { name: 'Magnesium',       source: 'Almonds and pumpkin seeds', description: 'A mineral naturally abundant in nuts and seeds' },
      { name: 'Natural Nitrates',source: 'Beets',                    description: 'Naturally occurring compounds found in beets' },
      { name: 'Boron',           source: 'Dates',                    description: 'A trace mineral naturally present in whole foods' },
      { name: 'Vitamin E',       source: 'Almonds',                  description: 'A fat-soluble vitamin found in almonds' },
      { name: 'Healthy Fats',    source: 'Almonds and coconut oil',  description: 'MCTs from coconut oil and monounsaturated fats from almonds' },
    ],
    ingredients: [
      {
        name: 'Dates', percentage: 45,
        role: 'Base & Binder',
        description: 'Whole Medjool dates — soft, naturally sweet, and unrefined. The foundation of every bar and the only sweetener used.',
        nutrients: ['NATURAL SUGARS', 'FIBRE', 'POTASSIUM', 'MAGNESIUM'],
      },
      {
        name: 'Almonds', percentage: 22,
        role: 'Texture',
        description: 'Whole blanched almonds for a satisfying crunch and a mild, buttery flavour that runs throughout every bite.',
        nutrients: ['VITAMIN E', 'HEALTHY FATS', 'MAGNESIUM', 'PROTEIN'],
      },
      {
        name: 'Pumpkin Seeds', percentage: 18,
        role: 'Texture',
        description: 'Whole pumpkin seeds scattered throughout. Lightly nutty with a satisfying bite and a naturally mineral-dense profile.',
        nutrients: ['ZINC', 'OMEGA-3', 'MAGNESIUM', 'PROTEIN'],
      },
      {
        name: 'Beets', percentage: 12,
        role: 'Flavour & Colour',
        description: 'Whole beetroot dried and ground to a fine powder. Earthy, slightly sweet, and the source of the bar\'s deep red colour.',
        nutrients: ['FOLATE', 'IRON', 'VITAMIN C', 'FIBRE'],
      },
      {
        name: 'Coconut Oil', percentage: 2,
        role: 'Binding Fat',
        description: 'Unrefined cold-pressed coconut oil. Holds the bar together and adds a subtle, clean richness.',
        nutrients: ['MCT', 'HEALTHY FATS', 'LAURIC ACID'],
      },
      {
        name: 'Salt', percentage: 1,
        role: 'Finish',
        description: 'A touch of sea salt to balance the natural sweetness of the dates and bring all the flavours into focus.',
        nutrients: ['SODIUM', 'TRACE MINERALS'],
      },
    ],
    color: {
      strip:  'from-red-900 via-red-500 to-red-900',
      text:   'text-red-400',
      border: 'border-red-500/40',
      glow:   'red-500/8',
      badge:  'bg-red-500/10 border-red-500/30 text-red-400',
    },
  },

  green: {
    id: 'green',
    name: 'Plan T',
    variant: 'GREEN',
    subtitle: "Men's Nutrition Bar",
    tagline: 'Dates · Almonds · Pumpkin Seeds · Spinach',
    description:
      'Clean, light, and grassy with a naturally mellow sweetness. Dates and almonds form the base, with spinach bringing an earthy depth and pumpkin seeds adding a light, nutty crunch.',
    status: 'Coming Soon',
    netWeight: '1.8 oz (50g)',
    registration: '26-437',
    allergens: 'Contains: Tree Nuts (Almonds)',
    keyMineral: 'Magnesium',
    productImage: '/Plan T Green Individual.png',
    tags: ['Whole Food', 'No Artificial Additives', '6 Ingredients', 'Small Batch', 'Handcrafted'],
    keyNutrients: [
      { name: 'Zinc',       source: 'Pumpkin seeds and almonds', description: 'An essential trace mineral found in pumpkin seeds and almonds' },
      { name: 'Magnesium',  source: 'Almonds and pumpkin seeds', description: 'A mineral naturally abundant in nuts and seeds' },
      { name: 'Iron',       source: 'Spinach',                   description: 'A mineral naturally found in dark leafy greens' },
      { name: 'Vitamin E',  source: 'Almonds',                   description: 'A fat-soluble vitamin naturally found in almonds' },
      { name: 'Folate',     source: 'Spinach',                   description: 'A B-vitamin naturally present in leafy greens' },
      { name: 'Vitamin K',  source: 'Spinach',                   description: 'A fat-soluble vitamin found in leafy greens' },
    ],
    ingredients: [
      {
        name: 'Dates', percentage: 42,
        role: 'Base & Binder',
        description: 'Whole Medjool dates — the natural binder and sole sweetener. Soft, rich, and entirely unrefined.',
        nutrients: ['NATURAL SUGARS', 'FIBRE', 'POTASSIUM', 'MAGNESIUM'],
      },
      {
        name: 'Almonds', percentage: 28,
        role: 'Base',
        description: 'Whole blanched almonds for a satisfying crunch and a mild, buttery flavour that lets the spinach speak.',
        nutrients: ['VITAMIN E', 'HEALTHY FATS', 'MAGNESIUM', 'PROTEIN'],
      },
      {
        name: 'Pumpkin Seeds', percentage: 15,
        role: 'Texture',
        description: 'Whole pumpkin seeds scattered throughout for a lightly nutty crunch and a naturally mineral-dense profile.',
        nutrients: ['ZINC', 'OMEGA-3', 'MAGNESIUM', 'PROTEIN'],
      },
      {
        name: 'Spinach', percentage: 12,
        role: 'Flavour & Colour',
        description: 'Whole spinach leaves dried and ground. Mild, earthy, and the source of the bar\'s distinctive green colour.',
        nutrients: ['IRON', 'VITAMIN K', 'FOLATE', 'MAGNESIUM'],
      },
      {
        name: 'Coconut Oil', percentage: 2,
        role: 'Binding Fat',
        description: 'Unrefined cold-pressed coconut oil for binding and a clean, subtle richness.',
        nutrients: ['MCT', 'HEALTHY FATS', 'LAURIC ACID'],
      },
      {
        name: 'Salt', percentage: 1,
        role: 'Finish',
        description: 'Sea salt to balance the natural sweetness and bring out the full flavour of each ingredient.',
        nutrients: ['SODIUM', 'TRACE MINERALS'],
      },
    ],
    color: {
      strip:  'from-green-900 via-green-500 to-green-900',
      text:   'text-green-400',
      border: 'border-green-500/40',
      glow:   'green-500/8',
      badge:  'bg-green-500/10 border-green-500/30 text-green-400',
    },
  },

  orange: {
    id: 'orange',
    name: 'Plan T',
    variant: 'ORANGE',
    subtitle: "Men's Nutrition Bar",
    tagline: 'Dates · Almonds · Turmeric · Ginger · Raw Honey',
    description:
      'Warm, spiced, and lightly sweet. Turmeric and ginger give it a bold, aromatic heat while dates and raw honey provide natural sweetness, and almonds round it out with crunch and body.',
    status: 'Coming Soon',
    netWeight: '1.8 oz (50g)',
    registration: '26-437',
    allergens: 'Contains: Tree Nuts (Almonds)',
    keyMineral: 'Manganese',
    productImage: '/Plan T Orange Individual.png',
    tags: ['Whole Food', 'No Artificial Additives', '6 Ingredients', 'Small Batch', 'Handcrafted'],
    keyNutrients: [
      { name: 'Curcumin',  source: 'Turmeric',           description: 'The primary active compound naturally found in turmeric root' },
      { name: 'Gingerol',  source: 'Ginger root',         description: 'The main bioactive compound naturally present in ginger' },
      { name: 'Vitamin E', source: 'Almonds',             description: 'A fat-soluble vitamin naturally found in almonds' },
      { name: 'Manganese', source: 'Turmeric and ginger', description: 'An essential trace mineral found in spices and nuts' },
      { name: 'Enzymes',   source: 'Raw honey',           description: 'Naturally occurring enzymes present in unprocessed honey' },
      { name: 'Magnesium', source: 'Almonds',             description: 'A mineral naturally abundant in almonds' },
    ],
    ingredients: [
      {
        name: 'Dates', percentage: 40,
        role: 'Base & Binder',
        description: 'Whole Medjool dates — the structural base of the bar and its primary unrefined sweetener.',
        nutrients: ['NATURAL SUGARS', 'FIBRE', 'POTASSIUM', 'MAGNESIUM'],
      },
      {
        name: 'Almonds', percentage: 28,
        role: 'Texture & Body',
        description: 'Whole blanched almonds for structure, crunch, and a mild neutral base that lets the spices lead.',
        nutrients: ['VITAMIN E', 'HEALTHY FATS', 'MAGNESIUM', 'PROTEIN'],
      },
      {
        name: 'Turmeric', percentage: 16,
        role: 'Spice & Colour',
        description: 'Whole ground turmeric root. Earthy, slightly bitter, and responsible for the bar\'s warm golden hue.',
        nutrients: ['CURCUMIN', 'MANGANESE', 'IRON', 'ANTIOXIDANTS'],
      },
      {
        name: 'Ginger', percentage: 8,
        role: 'Spice',
        description: 'Whole dried ginger root. Warm, fiery, and aromatic — pairs naturally with turmeric to build a complex spice profile.',
        nutrients: ['GINGEROL', 'SHOGAOL', 'ANTIOXIDANTS', 'MINERALS'],
      },
      {
        name: 'Raw Honey', percentage: 6,
        role: 'Sweetener',
        description: 'Unfiltered, unheated raw honey. Floral and complex — adds a gentle sweetness and helps bind the bar.',
        nutrients: ['NATURAL SUGARS', 'ENZYMES', 'ANTIOXIDANTS', 'TRACE MINERALS'],
      },
      {
        name: 'Salt', percentage: 2,
        role: 'Finish',
        description: 'Sea salt to cut through the sweetness and sharpen the warm spice notes.',
        nutrients: ['SODIUM', 'TRACE MINERALS'],
      },
    ],
    color: {
      strip:  'from-orange-900 via-orange-500 to-orange-900',
      text:   'text-orange-400',
      border: 'border-orange-500/40',
      glow:   'orange-500/8',
      badge:  'bg-orange-500/10 border-orange-500/30 text-orange-400',
    },
  },

  purple: {
    id: 'purple',
    name: 'Plan T',
    variant: 'PURPLE',
    subtitle: "Men's Nutrition Bar",
    tagline: 'Dates · Brazil Nuts · Maca · Pomegranate · Raw Honey',
    description:
      'Deep, fruity, and distinctly rich. Pomegranate and raw honey sit over a base of Medjool dates and Brazil nuts, with maca adding an earthy, malty depth unlike any other bar in the line.',
    status: 'Coming Soon',
    netWeight: '1.8 oz (50g)',
    registration: '26-437',
    allergens: 'Contains: Tree Nuts (Brazil Nuts)',
    keyMineral: 'Selenium',
    productImage: '/Plan T Purple Individual.png',
    tags: ['Whole Food', 'No Artificial Additives', '6 Ingredients', 'Small Batch', 'Handcrafted'],
    keyNutrients: [
      { name: 'Selenium',     source: 'Brazil nuts',   description: 'One of the most selenium-dense whole foods available' },
      { name: 'Ellagic Acid', source: 'Pomegranate',   description: 'A polyphenol naturally unique to pomegranate' },
      { name: 'Punicalagins', source: 'Pomegranate',   description: 'Antioxidant compounds naturally found in pomegranate' },
      { name: 'Amino Acids',  source: 'Maca',          description: 'Naturally occurring protein building blocks in maca root' },
      { name: 'Healthy Fats', source: 'Brazil nuts',   description: 'High in oleic and linoleic fatty acids' },
      { name: 'Vitamin C',    source: 'Pomegranate',   description: 'A water-soluble vitamin naturally present in pomegranate' },
    ],
    ingredients: [
      {
        name: 'Dates', percentage: 42,
        role: 'Base & Binder',
        description: 'Whole Medjool dates — soft, caramel-sweet, and the structural core that holds every bar together.',
        nutrients: ['NATURAL SUGARS', 'FIBRE', 'POTASSIUM', 'MAGNESIUM'],
      },
      {
        name: 'Brazil Nuts', percentage: 28,
        role: 'Base',
        description: 'Whole Brazil nuts with a rich, creamy texture and a distinctly buttery flavour. One of the densest whole-food nuts available.',
        nutrients: ['SELENIUM', 'HEALTHY FATS', 'MAGNESIUM', 'PROTEIN'],
      },
      {
        name: 'Maca', percentage: 14,
        role: 'Flavour Depth',
        description: 'Whole maca root dried and ground. Earthy and malty with a subtle sweetness — the most distinctive ingredient in the line.',
        nutrients: ['AMINO ACIDS', 'IRON', 'CALCIUM', 'B-VITAMINS'],
      },
      {
        name: 'Pomegranate', percentage: 12,
        role: 'Flavour & Colour',
        description: 'Whole pomegranate dried and ground. Tart, jewel-bright, and intensely fruity — gives the bar its deep purple hue.',
        nutrients: ['ELLAGIC ACID', 'PUNICALAGINS', 'VITAMIN C', 'ANTIOXIDANTS'],
      },
      {
        name: 'Raw Honey', percentage: 3,
        role: 'Sweetener',
        description: 'Unfiltered raw honey for binding and a layered natural sweetness that complements the pomegranate tartness.',
        nutrients: ['NATURAL SUGARS', 'ENZYMES', 'ANTIOXIDANTS', 'TRACE MINERALS'],
      },
      {
        name: 'Salt', percentage: 1,
        role: 'Finish',
        description: 'Sea salt to balance the fruit-forward profile and bring out the depth of the nuts.',
        nutrients: ['SODIUM', 'TRACE MINERALS'],
      },
    ],
    color: {
      strip:  'from-purple-900 via-purple-500 to-purple-900',
      text:   'text-purple-400',
      border: 'border-purple-500/40',
      glow:   'purple-500/8',
      badge:  'bg-purple-500/10 border-purple-500/30 text-purple-400',
    },
  },

  black: {
    id: 'black',
    name: 'Plan T',
    variant: 'BLACK',
    subtitle: "Men's Nutrition Bar",
    tagline: 'Dates · Almonds · Cacao · Maca Powder · Coconut Oil',
    description:
      'Intense, dark, and deeply satisfying. Cacao leads with its natural bitterness, layered with maca powder and almonds, all bound with Medjool dates and coconut oil. Finished with flaked sea salt.',
    status: 'Coming Soon',
    netWeight: '1.8 oz (50g)',
    registration: '26-437',
    allergens: 'Contains: Tree Nuts (Almonds)',
    keyMineral: 'Magnesium',
    productImage: '/Plan T Black Individual.png',
    tags: ['Whole Food', 'No Artificial Additives', '6 Ingredients', 'Small Batch', 'Handcrafted'],
    keyNutrients: [
      { name: 'Magnesium',              source: 'Cacao and maca powder', description: 'One of the richest dietary sources of magnesium' },
      { name: 'Flavonoids',             source: 'Cacao',                 description: 'Key phytochemicals naturally present in whole cacao' },
      { name: 'Adaptogenic Compounds',  source: 'Maca powder',           description: 'Naturally occurring compounds found in maca root' },
      { name: 'Theobromine',            source: 'Cacao',                 description: 'A naturally occurring alkaloid found in cacao' },
      { name: 'Iron',                   source: 'Maca powder and cacao', description: 'A mineral naturally present in maca root and cacao' },
      { name: 'Healthy Fats',           source: 'Almonds and coconut oil', description: 'A diverse fatty acid profile from two whole-food sources' },
    ],
    ingredients: [
      {
        name: 'Dates', percentage: 35,
        role: 'Base & Binder',
        description: 'Whole Medjool dates — the binding agent and only sweetener. Used sparingly to let the cacao lead.',
        nutrients: ['NATURAL SUGARS', 'FIBRE', 'POTASSIUM', 'MAGNESIUM'],
      },
      {
        name: 'Almonds', percentage: 25,
        role: 'Crunch',
        description: 'Whole blanched almonds for structure and a clean, neutral crunch against the soft cacao base.',
        nutrients: ['VITAMIN E', 'HEALTHY FATS', 'MAGNESIUM', 'PROTEIN'],
      },
      {
        name: 'Cacao', percentage: 20,
        role: 'Dominant Flavour',
        description: 'Minimally processed whole cacao. Deeply bitter, complex, and roasted — the defining flavour of this bar.',
        nutrients: ['FLAVONOIDS', 'THEOBROMINE', 'MAGNESIUM', 'IRON'],
      },
      {
        name: 'Maca Powder', percentage: 15,
        role: 'Depth',
        description: 'Whole maca root dried and ground. Earthy, malty, and subtly sweet — adds body and a layer of complexity to the cacao base.',
        nutrients: ['IRON', 'CALCIUM', 'AMINO ACIDS', 'B-VITAMINS'],
      },
      {
        name: 'Coconut Oil', percentage: 4,
        role: 'Binding Fat',
        description: 'Unrefined cold-pressed coconut oil. Holds the bar together and adds a subtle depth that complements the cacao.',
        nutrients: ['MCT', 'HEALTHY FATS', 'LAURIC ACID'],
      },
      {
        name: 'Sea Salt', percentage: 1,
        role: 'Finish',
        description: 'Flaked sea salt on the surface. Cuts the bitterness and brings every flavour into sharp focus.',
        nutrients: ['SODIUM', 'TRACE MINERALS'],
      },
    ],
    color: {
      strip:  'from-zinc-700 via-zinc-400 to-zinc-700',
      text:   'text-zinc-300',
      border: 'border-zinc-500/40',
      glow:   'zinc-500/8',
      badge:  'bg-zinc-500/10 border-zinc-500/30 text-zinc-300',
    },
  },
};
